import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Button,
  message,
  Spin,
  Upload,
  Popconfirm,
  Radio,
  notification,
} from "antd";
import Search from "antd/es/input/Search";
import { useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  DeleteOutlined,
  PlusCircleOutlined,
  ImportOutlined,
  PrinterOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import axios from "axios";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_UPDATE_PARCEL,
} from "../../API/apiUrls";
import dayjs from "dayjs";
import { excelForPostOffice } from "../cancelContract/export/ExportPostOffice";
import GetRoundForRePrint from "./modal/GetRoundForRePrint";
import { findParcelDuplicates } from "../../../hook/CheckDuplicateParcel";

const Main = () => {
  const [importLoad, setImportLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [data, setData] = useState([]);
  const [postOfficeTypeSelect, setPostOfficeTypeSelect] = useState(1);
  const [isModalGetDataForRePrint, setIsModalGetDataForRePrint] =
    useState(false);

  const onSearch = (value) => {
    const vlaueTrim = value.trim();
    let result = data.filter(
      (item) =>
        (item.contno && item.contno.includes(vlaueTrim)) ||
        (item.customerFullname && item.customerFullname.includes(vlaueTrim)) ||
        (item.parcelNo && item.parcelNo.includes(vlaueTrim)) ||
        (item.parcelNoResponse && item.parcelNoResponse.includes(vlaueTrim))
    );
    if (value) {
      setArrayTable(result);
    } else {
      setArrayTable(data);
    }
  };

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const arrayBuffer = event.target.result; // อ่านไฟล์เป็น ArrayBuffer
      const workbook = XLSX.read(new Uint8Array(arrayBuffer), {
        type: "array",
      });
      const allData = [];

      // วนลูปผ่านทุกชีตในไฟล์
      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const sheetData = XLSX.utils.sheet_to_json(sheet);
        // ดึงข้อมูลเฉพาะคอลัมน์ตาม header ที่ต้องการ
        const filteredData = sheetData.map((row) => ({
          id: row["id"],
          datetime: row["รอบวันที่"] || "",
          contractNo: row["เลขที่สัญญา"] || "",
          customerFullname: row["ชื่อลูกค้า"] || "",
          customerTypeID: row["ประเภทลูกค้า"],
          parcelNo: row["ems จดหมาย"] || "",
          parcelNoResponse: row["ems ใบตอบกลับ"] || "",
          zipcode: row["zipcode"] || "",
        }));

        // รวมข้อมูลจากชีตนี้เข้าไปใน allData
        allData.push(...filteredData);
      });

      let i = 1;
      if (allData) {
        const newData = allData.map((item) => ({
          ...item,
          key: i++,
        }));

        console.log(newData);
        setArrayTable(newData);
        setData(newData);
        setImportLoad(false);
      }
    };

    reader.readAsArrayBuffer(file); // อ่านไฟล์เป็น ArrayBuffer
    return false; // ป้องกันการอัพโหลดอัตโนมัติ
  };

  const uploadProps = {
    customRequest: ({ file, onSuccess, fileList }) => {
      handleFileUpload(file);
      if (file.status !== "uploading") {
        // console.log(file, fileList);
      } else {
        onSuccess(); // Call onSuccess when the file is handled
      }
    },
    showUploadList: importLoad,
  };

  const handlePreDatasend = () => {
    const preData = (data || []).map(({ id, parcelNo, parcelNoResponse }) => ({
      id,
      parcelNo,
      parcelNoResponse,
      //status: (status respone)
    }));

    console.log("preData", preData);
    insertData(preData);
  };

  const insertData = async (preData) => {
    setLoading(true);
    if (!preData || preData.length === 0) {
      message.error("ไม่มีข้อมูล !!");
      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(
        `${BASE_URL_BEN}${POST_UPDATE_PARCEL}`,
        preData,
        { headers: HEADERS_EXPORT_BEN }
      );
      const { status, data } = res;

      if (status === 200) {
        message.success("สร้างข้อมูลใหม่สำเร็จ");
      } else if (status === 201) {
        message.warning(String(data?.OK));
      } else {
        message.success(`สำเร็จ (รหัส ${status})`);
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 500) {
        message.error(`ข้อมูลเลขไปรษณีย์ซ้ำ !!`);
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`
        );
      }
    } finally {
      setLoading(false);
      setImportLoad(false);
    }
  };

  const confirmInsert = () => {
    setImportLoad(true);

    const { sameField, crossField } = findParcelDuplicates(arrayTable);

    if (sameField.length || crossField.length) {
      notification.error({
        message: "ไม่สามารถบันทึกได้ !",
        description: (
          <div>
            <div>เนื่องจากมีข้อมูลซ้ำกันกรุณาตรวจสอบข้อมูล excel </div>

            {sameField.length > 0 && (
              <div style={{ marginTop: 8, color: "red" }}>
                ซ้ำกันในแถว:
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  {[...new Set(sameField.map((d) => d.value))].map(
                    (value, index) => (
                      <li key={index}>{value}</li>
                    )
                  )}
                </ul>
              </div>
            )}

            {crossField.length > 0 && (
              <div style={{ marginTop: 8, color: "orange" }}>
                ซ้ำข้ามคอลัมน์:
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  {[...new Set(crossField.map((d) => d.value))].map(
                    (value, index) => (
                      <li key={index}>{value}</li>
                    )
                  )}
                </ul>
              </div>
            )}
          </div>
        ),
        duration: 20,
      });

      setImportLoad(false);
      return;
    }

    // ผ่านทุกเงื่อนไข ค่อยยิง API
    handlePreDatasend();
  };

  const cancelInsert = () => {
    message.error("ยกเลิกการนำเข้าข้อมูล");
  };

  const confirmDelete = (record) => {
    if (!record || record.key == null) {
      message.error("ไม่พบรายการที่จะลบ");
      return;
    }
    // ลบออกจากทั้ง arrayTable และ data (ใช้ functional update กันค่าเก่า)
    setArrayTable((prev) => prev.filter((row) => row.key !== record.key));
    setData((prev) =>
      Array.isArray(prev) ? prev.filter((row) => row.key !== record.key) : []
    );

    message.success(`ลบสัญญาเรียบร้อย ${record.contract_no}`);
  };

  const cancelDelete = (e) => {
    console.log(e);
    message.error("ยกเลิกการลบสัญญา");
  };

  const handleChangeRadio = (value) => {
    console.log("value", value);
    setPostOfficeTypeSelect(value);
  };

  const handleClick = async () => {
    setLoading(true);
    try {
      await excelForPostOffice(data, postOfficeTypeSelect);
      message.success("โหลด Excel สำเร็จ");
    } catch (e) {
      console.error(e);
      message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "รอบวันที่",
      align: "center",
      render: (text, record) => (
        <>
          {record.datetime
            ? dayjs(record.datetime).add(543, "year").format("DD MMM YY")
            : null}
        </>
      ),
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "contract_no",
      key: "contract_no",
      align: "center",
      render: (text, record) => (
        <>{record.contract_no ? record.contract_no : null}</>
      ),
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "customerFullname",
      key: "customerFullname",
      align: "center",
      render: (text, record) => (
        <>{record.customerFullname ? record.customerFullname : null} </>
      ),
    },
    {
      title: "ประเภทลูกค้า",
      align: "center",
      render: (text, record) => <>{record.customerTypeID}</>,
    },
    {
      title: "ems จดหมาย",
      dataIndex: "parcelNo",
      key: "parcelNo",
      align: "center",
    },
    {
      title: "ems ใบตอบกลับ",
      dataIndex: "parcelNoResponse",
      key: "parcelNoResponse",
      align: "center",
    },

    {
      title: "การจัดการ",
      align: "center",
      render: (text, record) => (
        <>
          <Popconfirm
            title="ลบสัญญา"
            description="คุณต้องการลบสัญญานี้ใช่หรือไม่ ?"
            onConfirm={() => {
              confirmDelete(record);
            }}
            onCancel={cancelDelete}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <Button style={{ fontSize: "16px", color: "red" }}>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={"12"} style={{ textAlign: "start" }}>
            <Popconfirm
              title="นำเข้าข้อมูล"
              description="คุณต้องการนำเข้าข้อมูลทั้งหมดใช่หรือไม่"
              onConfirm={confirmInsert}
              onCancel={cancelInsert}
              okText="ยืนยัน"
              cancelText="ยกเลิก"
            >
              <Button
                color="blue"
                variant="outlined"
                style={{ marginRight: "10px" }}
              >
                <PlusCircleOutlined style={{ fontSize: "24px" }} />
                บันทึกข้อมูล
              </Button>
            </Popconfirm>
          </Col>
          <Col span={"12"} style={{ textAlign: "end" }}>
            <Space direction="vertical" size={12}>
              <Upload {...uploadProps}>
                <Button
                  color="green"
                  variant="outlined"
                  style={{ marginRight: "5px" }}
                  icon={<ImportOutlined />}
                >
                  นำเข้า Excel
                </Button>
              </Upload>
            </Space>
          </Col>
          <Col span={"12"} style={{ textAlign: "start", marginTop: "10px" }}>
            <Button
              type="text"
              icon={
                <FilePdfOutlined
                  style={{
                    fontSize: "24px",
                  }}
                />
              }
              onClick={() => setIsModalGetDataForRePrint(true)}
              color="orange"
              variant="outlined"
            >
              Re-Print
            </Button>
          </Col>
          <Col span={"12"} style={{ textAlign: "end", marginTop: "10px" }}>
            <Radio.Group
              style={{ marginRight: "10px" }}
              name="postOfficeType"
              defaultValue={postOfficeTypeSelect}
              options={[
                { value: 1, label: "ลงทะเบียน" },
                { value: 2, label: "EMS" },
              ]}
              onChange={(e) => {
                handleChangeRadio(e.target.value);
              }}
            />
            <Button
              type="text"
              icon={
                <PrinterOutlined
                  style={{
                    fontSize: "24px",
                    color: data.length === 0 ? "grey" : "green",
                  }}
                />
              }
              onClick={handleClick}
              disabled={data.length === 0}
              style={{
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              พิมพ์
            </Button>
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={"12"} style={{ textAlign: "start" }}>
              <Search
                enterButton
                placeholder="ค้นหาสัญญา"
                onSearch={onSearch}
                style={{
                  width: 200,
                }}
                size="large"
              />
            </Col>
            <Col span={"24"}>
              <Table
                style={{ marginTop: "10px" }}
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                footer={() => (
                  <p>จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable.length}</p>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalGetDataForRePrint ? (
        <GetRoundForRePrint
          open={isModalGetDataForRePrint}
          close={setIsModalGetDataForRePrint}
        />
      ) : null}
    </>
  );
};

const UpdateParcelNumber = MotionHoc(Main);
export default UpdateParcelNumber;
